import script from "./NovoProfissional.vue?vue&type=script&lang=ts&setup=true"
export * from "./NovoProfissional.vue?vue&type=script&lang=ts&setup=true"

import "./NovoProfissional.vue?vue&type=style&index=0&id=029da91c&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-029da91c"]])

export default __exports__